import React,{ Component} from "react";
import {Link, NavLink, useNavigate } from "react-router-dom";
import FakeSession from "./FakeSession";

import queryString from 'query-string';
import { Action } from 'react-reflux';


export const  withNavigation = (Component : Component) => {
  return props => <Component {...props} navigate={useNavigate()} />;
} 

class Jobqadm extends React.Component {

resturl=sessionStorage.getItem("REST_URL");

  constructor(){
    super();
  }//end func


//	SAD_PAYMENT_GROUPID: '',
  state = {
    sadLoaded: false
    ,rcpLoaded: false
	,statements: []
	, arrInstanceid: []
	,DEC_NAM:''
	,crit :{
		daterange:''
		,date1: ''
		,date2: ''
		,dec_cod: ''
		,prevs_dec_cod: ''// the prevs dec_cod crit
		,regnum: ''
		,POST_ENTRY: 0
		,STATEMENT_INSTANCE_ID: ''
		,REQUEST_NAME:'PAYMENT VOUCHER'
		,cuo_cod: sessionStorage.getItem("USER_CUO_COD")
		,AW_USERNAME: sessionStorage.getItem("AW_USERNAME")
		,CUSTOMERACCOUNT: sessionStorage.getItem("CUSTOMERACCOUNT")
		}

  };
  /*
  
  18-APR-22
	date1: '2023-01-01',
	date2: '2023-01-31',
	dec_cod: 'D6241',
	cuo_cod: 'PSD'

	date1: '2022-04-18',
	date1: '2022-04-18',
	dec_cod: 'D6069',
	cuo_cod: 'PSD'


  */
  
  
  	url=this.resturl+'rarjobq/';




	
	
	rcpDataRows = [];
	sadDataRows = [];
	cuoDataRows = [<option key="cuo_opt_00" value='' > * * * </option>];
	decDataRows = [<option key="dec_opt_00" value='' > * * * </option>];
	decList = [];
	dateDataRows = [];


//handleForm = async event => {





 

 
 
   








   

   componentDidUpdate(prevProps) {
  // do something
  console.log("componentDidUpdate prevProps: "+JSON.stringify(prevProps));


	if (this.state.rcpLoaded==true && this.state.sadLoaded==false ){
		//&& this.sadDataRows.length==0
	//	this.fetchSad();
		
		
/*
this.setState({ 
		...this.state
		, sadLoaded:true
		}, ()=>{
			});
		this.fetchSad();
*/		
		
		}//end if

		


  
}//end func
     
	 
	 
	handleKeypress = (event) => {
 // detect event keys
 if (event.keyCode == 13) {
   //console.log("event.keyCode == 13");
   this.critChange({  target:{name:"regnum",value:''} });
   //this.fetchRcp();
 }		 
	 }//end func
	 
	 
 componentWillUnmount() {
    // Make sure to remove the DOM listener when the component is unmounted.
     document.body.removeEventListener('keypress', this.handleKeypress.bind(this));
  }	 
	 
  async componentDidMount() {
	  document.title =   "Job Queue";	
	  //this.nv.addEventListener("keypress", this.handleKeypress  );
	  document.body.addEventListener('keypress', this.handleKeypress.bind(this));


	  console.log("sessionStorage.getItem(USER_CUO_COD): "+sessionStorage.getItem("USER_CUO_COD"));
    console.log('componentDidMount');
/*

*/
if (sessionStorage.getItem("AW_USERNAME")==null){
	window.location="/logout";
	return;
	}
	this.parsejobqoptions();
	
	let crit=this.state.crit;
	if (sessionStorage.getItem("prevs_dec_cod")){
		crit.dec_cod=sessionStorage.getItem("prevs_dec_cod");
		this.setState((prev)=>{
			return {...prev, crit:crit}
		});
		}//end if
		
	if (sessionStorage.getItem("USER_CUO_COD")){
		crit.cuo_cod=sessionStorage.getItem("USER_CUO_COD");
		this.setState((prev)=>{
			return {...prev, crit:crit}
		});
		}//end if
		
	
	await this.getjobqcrit();//will call fetchRcp after
	
	
	
  }//end function

 getjobqcrit(){
	
		const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( {USERNAME:sessionStorage.getItem("AW_USERNAME")} )
	  };	
	  fetch(this.resturl+'rarlogin/getjobqcrit',requestOptions)
		  .then(res => res.json())
		  .then(res => this.aftergetjobqcrit(res))
		  .catch(err => console.log(err));	
	
}//end function

 getdclstatements(){
	
		const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( this.state.crit )
	  };	
	  fetch(this.resturl+'rarjobq/dclstatements',requestOptions)
		  .then(res => res.json())
		  .then(res => this.aftergetdclstatements(res))
		  .catch(err => console.log(err));	
	
}//end function

changeStmt(e){
	const STATEMENT_INSTANCE_ID=e.target.value;
	console.log("changeStmt STATEMENT_INSTANCE_ID:"+STATEMENT_INSTANCE_ID);
	let temp=this.state;
	temp.crit.STATEMENT_INSTANCE_ID=STATEMENT_INSTANCE_ID;
	this.setState(temp
	, ()=>{
		this.setDEC_NAM(e.target);
		this.fetchSad();
		}
		);
	
}//end func

setDEC_NAM(combo){
	//const combo=document.getElementsByName("STATEMENT_INSTANCE_ID")[0];
	//const options=combo.options;
	console.log("combo.options.length: "+combo.options.length);
	const text=combo.options[combo.selectedIndex].text;
	const arrText=text.replace(" ", ",").split(",");
	if (combo.selectedIndex==0){
		let temp=this.state;
		temp.DEC_NAM="";
		this.setState(temp);
		}//end if
	else if (arrText.length>1){
		const decCod=arrText[0];
		console.log("decCod: "+decCod);
		for (const elem of this.decList){
			//console.log("elem.DEC_NAM: "+JSON.stringify(elem));
			if (elem.DEC_COD==decCod){
				console.log("elem.DEC_NAM: "+elem.DEC_NAM);
				let temp=this.state;
				temp.DEC_NAM=(""+elem.DEC_NAM).substring(0,20);
				this.setState(temp);
				//this.setState({...this.state, DEC_NAM:elem.DEC_NAM});
				}//end if
			}//end for
		}//end if
	
	
}//end func

 aftergetdclstatements(res){
	
	let tempOpts=[];
	let rowcount=1;
	   if (res.length)
    for (let item of res) {
      //console.log('item: '+JSON.stringify(item));
	  const key="lsstmt"+rowcount;
	  
      const opt = <option key={key} value={item['INSTANCE_ID']}  >{item['STATEMENT']}</option>;
          
      tempOpts.push(opt);
	  rowcount++;
    }//end for

	let temp=this.state;
	temp.statements=tempOpts;
	this.setState(temp, ()=>{
		console.log("aftergetdclstatements this.state.STATEMENT_INSTANCE_ID: "+this.state.crit.STATEMENT_INSTANCE_ID);
	if (this.state.crit.STATEMENT_INSTANCE_ID!=""){
		//while (!document.getElementsByName("INSTANCEID[]")){}
		this.jscheckboxall('INSTANCEID[]', true);
		this.jsTOTAL_AMT_TBP();
		}//end if		
	});
}//end function

critChange(e){

let {name, value}=e.target;	  

if (name=="regnum")//3879
	value=document.getElementsByName("regnum")[0].value;
	
	//value=e.target.checked?document.getElementsByName("dec_cod")[0].value:"";

	//name="dec_cod";

console.log('critChange name, value: '+name+', '+value);
	
//	let crit=this.state.crit;
//	crit[name]=value;
let name2="", value2="", name3="", value3="", DEC_NAM=this.state.DEC_NAM;
if (name=="dec_cod"){
	name2="prevs_dec_cod";
	value2=value;
	name3="STATEMENT_INSTANCE_ID";
	value3="";
	DEC_NAM="";
	sessionStorage.setItem("prevs_dec_cod", value);
	}//end if


if (name=="daterange"){
	name2="date1";
	name3="date2";
	value2=value.substring(0,10);
	value3=value.substring(11,21);
	}//end if
	
	if (name=="cuo_cod")
		sessionStorage.setItem("USER_CUO_COD", value);

	this.setState({
	...this.state
		,DEC_NAM: DEC_NAM
		,crit:{
	...this.state.crit
		,[name]: value
		,[name2]: value2
		,[name3]: value3
	}}, () => {
		console.log("daterange: "+this.state.crit.daterange);
		console.log("date1: "+this.state.crit.date1);
		console.log("dec_cod: "+this.state.crit.dec_cod);
		console.log("cuo_cod: "+this.state.crit.cuo_cod);
		if (document.getElementById("cbfilterdec"))
			document.getElementById("cbfilterdec").checked=true;
		this.rcpDataRows=[];
		this.sadDataRows=[];
		this.fetchRcp();
		}//end func
		);
	
}//end func

async aftergetjobqcrit(res){
	
	sessionStorage.setItem("searchcrit", JSON.stringify(res));
	await this.fetchRcp();
	
	
}//end func


afterfetchRcp(res){
	

	
   	let tempRows=[];
   let rowcount=1;
   
   if (res.length){
    for (let item of res) {
      //console.log('item: '+JSON.stringify(item));
	  const key="tblrcp"+rowcount;
      const row = (
        <tr key={key}>
          <td align='right' >{rowcount}</td>
          <td align='center' >&nbsp;{item['CUO_COD']}</td>
          <td align='center' >&nbsp;{item['SPG_DAT']}</td>
          <td align='center' >&nbsp;{item['REQUEST_TYPE']}</td>
          <td align='left' title={item['REG_NUM_RANGE']} >
        <NavLink
          to={"/sad"}
          state={{
		  sad_payment_groupid:item['SAD_PAYMENT_GROUPID'] 
		  ,dec_cod: this.state.crit.dec_cod
		  ,cuo_cod: this.state.crit.cuo_cod
		  ,aw_username: this.state.AW_USERNAME
		  }} 
        >
		<img src="img/openfolderarrow.png" border="0" />
		{item['MIN_REG_NUM']}
        </NavLink> 		  
		  </td>
		  <td align='center' >{item['NUM_ITM']}</td>
          <td align='right' >{item['FIN_AMT_TBP']}</td>
          <td align='center' >{item['DOC_NO']}</td>
          <td align='center' title={item['DATE_TIME']}  >{item['AGE_HR_MIN']}</td>
          <td align='left' >{item['DEC_NAM']}</td>
        </tr>
      );
      tempRows.push(row);
      rowcount++;
    }//end for
	
	this.rcpDataRows.push(tempRows);
	
	}//end if

/*
	else
		this.rcpmsg=res.error;

*/
		
	console.log('rcpDataRows: '+this.rcpDataRows.length);

	
	//if (this.rcpLoadedsad==false)
		this.setState({...this.state, rcpLoaded:true}, ()=>{this.fetchSad();});
	
	document.getElementsByName("regnum")[0].focus();
}//end func

   async  fetchRcp(){
   
   let params=this.state.crit;
   
   	if (document.getElementById("cbfilterdec")){
		if (document.getElementById("cbfilterdec").checked==false)
			params.dec_cod="";
		}//end if
			
	this.rcpDataRows = [];
   
   	this.setState({ 
	...this.state
	, rcpLoaded:false
	}, ()=>{
   
       		const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( params )
	  };	
	  fetch(this.resturl+'rarjobq/rcp',requestOptions)
		  .then(res => res.json())
		  .then(res => this.afterfetchRcp(res))
		  .catch(err => console.log(err));	

	});
 
}//end function



   async  fetchSad(){
   
   let params=this.state.crit;
   
   this.sadDataRows = [];
   
   	this.setState({ 
	...this.state
	, sadLoaded:false
	}, ()=>{
   
       		const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( params )
	  };	
	  fetch(this.resturl+'rarjobq/sad',requestOptions)
		  .then(res => res.json())
		  .then(res => this.afterfetchSad(res))
		  .catch(err => console.log(err));	

	});
 
}//end function


afterfetchSad(res){
	

	
   	let tempRows=[];
   let rowcount=1;
   
   if (res.length){
    for (let item of res) {
      //console.log('item: '+JSON.stringify(item));
	  const key="tblrcp"+rowcount;
	  let regNum=<><input type="checkbox" name="INSTANCEID[]" value={item['INSTANCEID']} onClick={(e)=>{this.jsTOTAL_AMT_TBP();}} id={key} /><label htmlFor={key} className="hand" >{item['REG_NUM']}</label></>;
	  if (this.state.crit.dec_cod=="" && this.state.crit.STATEMENT_INSTANCE_ID=="")
		  regNum=item['REG_NUM'];
	  
	  const ALERT_NOT_CHECKED=item['ALERT_NOT_CHECKED']==1?<img src="img/exclmarkorange.png" border="0" />:<img src="img/exclmarkorange.png" style={{visibility:"hidden"}} border="0" />;
	  
	  const navlink1=<NavLink 
		className="nodecor"
          to={"/sad"}
          state={{
			sad_payment_groupid:0
			,instanceid:item['INSTANCEID']
			,dec_cod: this.state.crit.dec_cod
			,cuo_cod: this.state.crit.cuo_cod
			,aw_username: this.state.AW_USERNAME
			}} 
        >
		{ALERT_NOT_CHECKED}
		&nbsp;{item['DEC_REF_NBR']}
        </NavLink>;
	  //const SHORT_DEC_REF_NBR=item['DEC_REF_NBR'].length>8?item['DEC_REF_NBR'].substring(0,8):item['DEC_REF_NBR'];
	
      const row = (
        <tr key={key}>
          <td align='right' >{rowcount}</td>
          <td align='center' >&nbsp;{item['FIN_ACC']}</td>
          <td align='center' >&nbsp;{item['AST_DAT']}</td>
          <td align='left' title={item['DEC_COD']+" "+item['DEC_NAM']} >{navlink1}</td>
		  <td align='left' >
			{regNum}
			<input name="REGNUM[]" type="hidden" value={item['REG_NUM']} />
		  </td>
          <td align='right' >{item['STR_FIN_AMT_TBP']}<input type="hidden" name="FIN_AMT_TBP[]" value={item['FIN_AMT_TBP']} /></td>
          <td align='right' >{item['PTY_NBR_ITM']}</td>
          <td align='left' >{item['CMP_NAM']}</td>
        </tr>
      );
      tempRows.push(row);
      rowcount++;
    }//end for
	
	this.sadDataRows.push(tempRows);

	}//end if

	this.setState({...this.state, sadLoaded:true});
	console.log('sadDataRows: '+this.sadDataRows.length);

	
	//if (this.rcpLoadedsad==false)
		
	this.getdclstatements();
	document.getElementsByName("regnum")[0].focus();
}//end func

openSad(instanceid){
//e.preventDefault();

const state={
			sad_payment_groupid:0
			,instanceid:instanceid
			,from_sad_finder:1
			};


//navigate(`/sad`,{state:state});

	}//end func

jscheckboxall(elemName, checkstate){
var i=0, len=document.getElementsByName(elemName).length;
console.log("elemName: "+elemName);
console.log("checkstate: "+checkstate);
for (i=0; i<len; i++){
	document.getElementsByName(elemName)[i].checked=checkstate;
	}// end for	
console.log("i after loops: "+i);
}//end func

jsTOTAL_AMT_TBP(){
	
var i=0, len=document.getElementsByName("INSTANCEID[]").length;
var TOTAL_AMT_TBP=0, NUM_SAD=0, LS_REGNUM='';
let arrInstanceid=[];
for (i=0; i<len; i++){
	if (document.getElementsByName("INSTANCEID[]")[i].checked==true){
		TOTAL_AMT_TBP+=Math.round(100*document.getElementsByName("FIN_AMT_TBP[]")[i].value)/100;
		if (LS_REGNUM!="")
			LS_REGNUM+=', ';
			
		LS_REGNUM+=document.getElementsByName("REGNUM[]")[i].value;
		arrInstanceid.push(document.getElementsByName("INSTANCEID[]")[i].value);
		NUM_SAD+=1;
		}// end if
	}// end for
let temp=this.state;
temp.arrInstanceid=arrInstanceid;
this.setState(temp);

//var nf = new Intl.NumberFormat();
var STATEMENT_INSTANCE_ID=document.getElementsByName("STATEMENT_INSTANCE_ID")[0].value;
if (STATEMENT_INSTANCE_ID>0 && NUM_SAD>0 && NUM_SAD!=len){
	//do not allow proceed if statement is selected
	//and not all entries are selected
	alert('When statement is selected all entries must be selected.\r\nRequest statement to be deleted and try again.');
	
	document.getElementsByName("LS_REGNUM")[0].value='';
	document.getElementsByName("TOTAL_AMT_TBP")[0].value='';
	//.toFixed(2)
	document.getElementsByName("NUM_SAD")[0].value='';
	if (!document.getElementById('submit01').classList.contains("hidden"))
		document.getElementById('submit01').classList.add("hidden");
	this.jscheckboxall("INSTANCEID[]",false);
	}//end if	
else{
	document.getElementsByName("LS_REGNUM")[0].value=LS_REGNUM;
	document.getElementsByName("TOTAL_AMT_TBP")[0].value=TOTAL_AMT_TBP.toLocaleString();
	//.toFixed(2)
	document.getElementsByName("NUM_SAD")[0].value=NUM_SAD;
	if (NUM_SAD>0){
		if (document.getElementById('submit01').classList.contains("hidden"))
			document.getElementById('submit01').classList.remove("hidden");
		}
	else{
		if (!document.getElementById('submit01').classList.contains("hidden"))
			document.getElementById('submit01').classList.add("hidden");
		}	
	//document.getElementById('submit01').disabled=(NUM_SAD>0)? false : true;	
	}//end else
	
	
}//end function

requestpaymentvoucher(){
	
const result=window.confirm("request voucher for the selected entries?");
if (!result)
	return;
		
const params={	
	AW_USERNAME: sessionStorage.getItem("AW_USERNAME")
	, AW_USERID: sessionStorage.getItem("USERID")
	, COU_COD: this.state.crit.cuo_cod
	, DEC_COD: this.state.crit.dec_cod
	, STATEMENT_INSTANCE_ID: this.state.crit.STATEMENT_INSTANCE_ID
	, POST_ENTRY: 0
	, LS_REGNUM: document.getElementsByName("LS_REGNUM")[0]?.value
	, REQUEST_NAME: "VOUCHER"
	, ARRAY_INSTANCEID: this.state.arrInstanceid
	};
	
	this.sadDataRows = [];
   
   	this.setState({ 
	...this.state
	, sadLoaded:false
	}, ()=>{
   
       		const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( params )
	  };	
	  fetch(this.resturl+'rarjobq/requestpaymentvoucher',requestOptions)
		  .then(res => res.json())
		  .then(res => this.afterrequestpaymentvoucher(res))
		  .catch(err => console.log(err));	

	});	
	
}//end func

afterrequestpaymentvoucher(res){
	console.log("afterrequestpaymentvoucher: "+JSON.stringify(res))
	if (!res.length){
		alert("something went wrong processing the request.\r\ntry again or contact admin");
		this.setState({...this.state, sadLoaded:true});
		return;
		}

	if (res.length==0){
		alert("something went wrong processing the request.\r\ntry again or contact admin");
		this.setState({...this.state, sadLoaded:true});
		return;
		}
	//const navigate = useNavigate();	
	const state={
		sad_payment_groupid:res[0].SAD_PAYMENT_GROUPID
		};		
	this.props.navigate("/sad", {state:state});
	
}//end func

parsejobqoptions(){
	
let band="";
let options=[];
const jobqoptions=JSON.parse(sessionStorage.getItem("jobqoptions"));
console.log("sessionStorage jobqoptions.length: "+jobqoptions.length);
//jobqoptions.length
jobqoptions.map((col, index) => {
	
	//console.log("col: "+JSON.stringify(col));
	if (band=="")
		band=col.BAND;
	
	const key=band+"_opt_"+index;

	if (col.BAND=='CUO')
		this.cuoDataRows.push(<option key={key} value={col.DATE_RANGE} >{col.DATE_RANGE}</option>);
	else if (col.BAND=='DEC'){
		this.decDataRows.push(<option key={key} value={col.DATE_RANGE} >{col.DATE_NAME}</option>);
		this.decList.push({DEC_COD:col.DATE_RANGE, DEC_NAM:col.DATE_NAME});
		}
	else if (col.BAND=='DATES')
		this.dateDataRows.push(<option key={key} value={col.DATE_RANGE} >{col.DATE_NAME}</option>);

	
	});//end map
		
if (sessionStorage.getItem("LAST_SAD_DATES"))
	if (sessionStorage.getItem("LAST_SAD_DATES")!=""){
		const daterange=sessionStorage.getItem("LAST_SAD_DATES");
		console.log("LAST_SAD_DATES daterange: "+daterange);

		let tempstate=this.state;
		tempstate.crit.daterange=daterange;
		tempstate.crit.date1=daterange.substring(0,10);
		tempstate.crit.date2=daterange.substring(11,21);

		this.setState({...this.state, tempstate}, ()=>{
			console.log(this.state.crit.date1+','+this.state.crit.date2);
			
			});


		/*
		this.setState((prev)=>{
			return {...prev, crit:temp}
		}, ()=>{
			console.log(this.state.crit.date1+','+this.state.crit.date2);
			
			});
			this.setState({crit:{ 
			...this.state.crit
			,date1: daterange.substring(0,10)
			,date2: daterange.substring(11,21)
			}}, ()=>{
			console.log(this.state.crit.date1+','+this.state.crit.date2);
			
			});
		*/

		/*
			this.setState((prev)=>{
				return {...prev, {crit:{
					date1:dates.substring(0,10)
					, date2:dates.substring(11,21)
				}}}
			}); 
		*/
			
			
			}//end if
	
}//end func

  render() {

  const queryStringParams = queryString.parse(window.location.search);
 //console.log('FakeSession: '+FakeSession.test);
 
  
//console.log('queryStringParams: '+JSON.stringify(queryStringParams));

	const htmresult=[];//JSX array 
		//console.log('this.state.dec_cod'+this.state.dec_cod);
		//console.log('this.state.cuo_cod'+this.state.cuo_cod);
		
		
let tblrcp=<fieldset className="fieldset1">
	<legend >Requests for Vouchers or Selectivity</legend>
	<table align="center" className="customers" >
	<thead>
	<tr>
	<th align="right" >#</th>
	<th align='center' >Office</th>
	<th align='center' >Date</th>
	<th align='center' >type</th>
	<th align='left' >1st E #</th>
	<th align='center' >Entries<br/>/Items</th>
	<th align='center' >Amount</th>
	<th align='center' >Voucher #</th>
	<th align='center' >Age (Hr:Min)</th>
	<th align='left' >Declarant</th>
	</tr>
	</thead>
	<tbody>
	{this.rcpDataRows}
	</tbody>
	</table>
	</fieldset>;	
			

let tblsad=	<fieldset className="fieldset1">
	<legend >Declarations not submitted for Payment Voucher or Selectivity</legend>
	<table align="center" border="0" >
	<tbody>
	<tr>
		<td align="center" colSpan="2"><button className="button hidden" id="submit01" onClick={(e)=>{this.requestpaymentvoucher();}} >request payment voucher for selected</button></td>
	</tr>
	</tbody>
	</table>
	<table align="center" className="customers"  >
	<thead>
	<tr>
	<td align="center"  colSpan="4"  >
		<select name="STATEMENT_INSTANCE_ID" value={this.state.crit.STATEMENT_INSTANCE_ID} onChange={(e)=>{this.changeStmt(e);}} >
		<option value='' > * * * statements * * * </option>
		{this.state.statements}
		</select>
	</td>
	<td align="center"    ><input type="text" size="4" name="NUM_SAD" readOnly className="gnsbro" style={{textAlign:"center"}} /></td>
	<td align="center"  colSpan="2"  ><input type="text" size="8" name="TOTAL_AMT_TBP" readOnly className="gnsbro" style={{textAlign:"center"}}  /></td>
	<td align="center"    >{this.state.DEC_NAM}</td>
	</tr>
	<tr>
	<th align="right" >#</th>
	<th align='center' >Acc#</th>
	<th align='center' >Assess</th>
	<th align='left' >Dec Ref. #</th>
	<th align='left' ><input type="checkbox" id="cbsad"  onClick={(e)=>{this.jscheckboxall('INSTANCEID[]', e.target.checked);  this.jsTOTAL_AMT_TBP();}} /><label htmlFor="cbsad" className="hand" >Reg #</label></th>
	<th align='center' >Amount</th>
	<th align='center' >Items</th>
	<th align='center' >Consignee</th>
	</tr>
	</thead>
	<tbody>
	{this.sadDataRows}
	</tbody>
	</table>
	<div align="center">
	<input name="LS_REGNUM" size="45" readOnly className="gnsbro" />
	</div>
	</fieldset>	;
	
return <>

	<table align="center" border="0" className="jobqcrit" cellSpacing="0" cellPadding="0" >
	<tbody>
	<tr>
		<td align='right'  >
			<NavLink to="/restartaws" title="Restart Asycuda" ><img src="img/wheeltool.png" border="0" height="21" /></NavLink>
			{/*className="tooltip" <span className="tooltiptext">Restart Asycuda</span>*/}
			&nbsp;&nbsp;
			Months:&nbsp;
		</td>
		
		<td align='left'>
		<select name="daterange" value={this.state.crit.daterange} onChange={(e) => this.critChange(e) } >
		{this.dateDataRows}
		</select>
		</td>
	</tr>
	<tr>
		<td align='right'>
		Declarant:&nbsp;</td>
		<td align='left'>
		<select name="dec_cod" value={this.state.crit.dec_cod} onChange={(e) => this.critChange(e) } >
		{this.decDataRows}
		</select>
		&nbsp;&nbsp;
		{
		this.state.crit.prevs_dec_cod && <>
		<input type="checkbox" id="cbfilterdec" onClick={(e)=>this.critChange({  target:{name:"dec_cod", value:"", checked:e.target.checked}  }) } /><label htmlFor="cbfilterdec" className="hand" >filter {this.state.crit.prevs_dec_cod}</label>	
		</>
		}
		
		</td>
	</tr>
	<tr>
	
		<td align='right'>Customs Office:&nbsp;</td>
		<td align='left'>
		<select name="cuo_cod" value={this.state.crit.cuo_cod} onChange={(e) => this.critChange(e) }  >
		{this.cuoDataRows}
		</select>
		</td>
	</tr>
	<tr>
		<td align='right'>Registration #:&nbsp;</td>
		<td align='left'>
		<input name="regnum" size="6" autoComplete="off" onFocus={(e)=>{e.target.select();}} style={{textAlign:"center"}} />
		&nbsp;
		<input type="image" src="img/Btn_Search_Normal.png" border="0" className="nopad" onClick={(e)=> this.critChange({  target:{name:"regnum",value:''}  })  }  />
		{/*
		<button className="nopad" onClick={(e)=> this.critChange({  target:{name:"regnum",value:''}  })  } ><img src="img/Btn_Search_Normal.png" border="0" /></button>
		*/}
		</td>
	</tr>
	</tbody>
	</table>
	
	
	
	<table align="center" style={{width:"98%"}} >
	<tbody>
	<tr valign="top" >
		<td align="center" style={{width:"48%"}} >
			{!this.state.sadLoaded && <><div align="center" ><img src="img/Loading_2.gif" border="0" height="36" /> . . . please wait</div></> }
			{this.state.sadLoaded && tblsad}
		</td>
		<td align="center"  style={{width:"1%"}} >&nbsp;</td>
		<td align="center" style={{width:"51%"}} >
			{!this.state.rcpLoaded && <><div align="center" ><img src="img/Loading_2.gif" border="0" height="36" /> . . . please wait</div></> }
			{this.state.rcpLoaded && tblrcp}
		</td>
	</tr>
	</tbody>
	</table>
	
	
	<div align="center" className="rcpmsg" >{this.rcpmsg}</div>
	
	
 
</>   ;
  }//end function
  

  
}//end class

export default withNavigation(Jobqadm);
